import CookieConsent from '~/themes/base/components/shop/CookieConsent'

export default {
  mixins: [CookieConsent],
}
